'use strict';

var FilterKpiFilterFactory = function FilterKpiFilterFactory(DemandFilter, angularHelper) {
  var filtersNamesList = ['FlightDateRangeFilterFactory', 'FlightLevelFilterFactory', 'FlightCabinFilterFactory', 'FlightLegFilterFactory', 'FlightSeasonFilterFactory', 'FlightDOWFilterFactory'];
  var injectedFilters = angularHelper.getProvidersByNames(filtersNamesList);
  function FilterKpiFilter() {
    DemandFilter.call(this, ['cabin', 'cabin-da', 'cabin-post-departure'], 'kpi-ribbon');
    this.registerFilters(injectedFilters);
  }
  FilterKpiFilter.constructor = FilterKpiFilter;
  FilterKpiFilter.prototype = Object.create(DemandFilter.prototype);
  return FilterKpiFilter;
};
FilterKpiFilterFactory.$inject = ['DemandFilterFactory', 'AngularHelper'];
module.exports = FilterKpiFilterFactory;